module.exports = __webpack_public_path__ + "img/opuspromo.c0026871.svg";